import { useEffect, useState } from "react";
import { backend, producturl } from "../../../../path";
import useRazorpay from "react-razorpay";
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { Button, Collapse, Modal } from "react-bootstrap";
import ScrollToTop from "../../../components/whatsapp connect";
import LoaderMain from "../../../layout/header/loader_sub";
import { Rating } from "@mui/material";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { HiOutlinePlus } from "react-icons/hi2";
import { LuMinus } from "react-icons/lu";

const RAZORPAY_KEY = process.env.REACT_APP_RAZORPAY_KEY;

function BuyNow(props) {
  const [loading, setLoading] = useState();
  const [error, setError] = useState();
  const [datas, setDatas] = useState([]);
  const [couponSuccess, setCouponSuccess] = useState("");
  const [Razorpay] = useRazorpay();
  const [formData, setFormData] = useState({
    country: "102",
  });
  const [address, setAddress] = useState([]);
  const [delAd, setDelAd] = useState(null);
  const [newAdd, setNewAdd] = useState({
    country: "102",
  });
  const [count, setCountry] = useState([]);
  const [open, setOpen] = useState(false);
  const [delivery, setDelivery] = useState(false);
  const [newDelivery, setNewDelivery] = useState(false);
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
  const [coupon, setCoupon] = useState(0);
  const [couponId, setCouponId] = useState("");
  const navigate = useNavigate();
  const handleProductRoute = (productId) => {
    navigate(`/product/${productId}`);
    // window.location.reload();
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    setDatas(props.data);
  }, []);

  const [authenticated, setAuthenticated] = useState(
    JSON.parse(localStorage.getItem("userdata"))
  );

  const fetchCountryData = () => {
    // Assuming setData, setError, and setLoading are state functions from useState
    setLoading(true);

    fetch(backend + "getcountry", {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setCountry(data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const fetchAddress = () => {
    setLoading(true);

    fetch(backend + "getaddress", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        // keep addresses and default select the most recent (last)
        setAddress(data);
        if (Array.isArray(data) && data.length > 0) {
          const last = data[data.length - 1];
          setFormData(last);
          setDelAd(last?.delivery_address_id);
        } else {
          setFormData({ country: "102" });
          setDelAd(null);
        }
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchCountryData();
    fetchAddress();
  }, []);

  const handlePayment = async (id, total, details, razorpayOrderId) => {
    if (!RAZORPAY_KEY) {
      toast.error("Payment gateway unavailable. Please contact support.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    if (!razorpayOrderId) {
      toast.error("Unable to initiate payment. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    const options = {
      key: RAZORPAY_KEY,
      amount: total * 100,
      currency: "INR",
      name: "Kerala Special",
      description: "Order Payment",
      image: "https://keralaspecial.in/storage/general/ks-logo32.png",
      order_id: razorpayOrderId,
      handler: function (response) {
        // alert(response.razorpay_payment_id);
        handleSuccessOrder(id, response.razorpay_payment_id);
      },
      prefill: {
        name: `${details?.first_name} ${details?.last_name}`,
        email: details?.email,
        contact: details?.contact,
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#3399cc",
      },
    };

    const rzp1 = new Razorpay(options);

    rzp1.on("payment.failed", function (response) {
      // alert(response.error.code);
      // alert(response.error.description);
      // alert(response.error.source);
      // alert(response.error.step);
      // alert(response.error.reason);
      // alert(response.error.metadata.order_id);
      // alert(response.error.metadata.payment_id);
    });

    rzp1.on("payment.success", function (response) { });
    setLoading(false);
    rzp1.open();
  };

  const handleSubmit = () => {
    if (!formData) {
      toast.error(`Form fields cannot be empty`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      // List of required fields and their corresponding display names
      const requiredFields = [
        { key: "first_name", displayName: "First Name" },
        {
          key: "house_name",
          displayName: "House Name / House Number / Apartment",
        },
        { key: "country", displayName: "Country" },
        { key: "state", displayName: "State" },
        { key: "city", displayName: "City" },
        { key: "pincode", displayName: "Pincode" },
        { key: "contact", displayName: "Contact" },
      ];
      // Check if any required field is missing or blank
      const invalidField = requiredFields.find((field) => {
        const value = formData[field.key];
        return typeof value !== "string" || value.trim() === ""; // Check if value is not a string or is empty or consists of only whitespace
      });

      if (invalidField) {
        toast.error(`${invalidField.displayName} cannot be blank`, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return; // Stop further execution
      }

      fetch(backend + "addaddress", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authenticated?.access_token}`,
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          if (!response.ok) {
            console.error(
              "Failed to register:",
              response.status,
              response.statusText
            );
            if (response.status === 409) {
              toast.error("Something Went Wrong", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            } else {
            }

            return;
          }

          response.json().then((data) => {
            handleOrderAddress(data);
            fetchAddress();
            setOpen(false);
            // Additional success handling code here
            toast.success("Primary Address Updated", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          });
          // navigate("/admin-users");
        })
        .catch((error) => { });
    }
  };
  const handleSubmitNewAddress = () => {
    // List of required fields and their corresponding display names
    const requiredFields = [
      { key: "first_name", displayName: "First Name" },
      {
        key: "house_name",
        displayName: "House Name / House Number / Apartment",
      },
      { key: "country", displayName: "Country" },
      { key: "state", displayName: "State" },
      { key: "city", displayName: "City" },
      { key: "pincode", displayName: "Pincode" },
      { key: "contact", displayName: "Contact" },
    ];

    // Check if any required field is missing or blank
    const invalidField = requiredFields.find((field) => {
      const value = newAdd[field.key];
      return typeof value !== "string" || value.trim() === ""; // Check if value is not a string or is empty or consists of only whitespace
    });

    if (invalidField) {
      toast.error(`${invalidField.displayName} cannot be blank`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    newAdd.is_primary = 1;
    fetch(backend + "addaddress", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
      body: JSON.stringify(newAdd),
    })
      .then((response) => {
        if (!response.ok) {
          console.error(
            "Failed to register:",
            response.status,
            response.statusText
          );
          if (response.status === 409) {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
          }

          return;
        }

        response.json().then((data) => {
          handleOrderAddress(data);
          fetchAddress();
          setOpen(false);
          setNewDelivery(false);
          toast.success("Address Added", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        });
        // navigate("/admin-users");
      })
      .catch((error) => { });
  };

  const handleOrder = () => {
    const sel = address?.find((a) => a?.delivery_address_id === delAd) || (address && address[address.length - 1]);
    if (!sel) {
      toast.info("Please add a delivery address to proceed with your order", {
        position: "top-right",
        autoClose: 3000,
      });
      if (!delivery) setDelivery(true);
      if (!address || address.length === 0) {
        setNewDelivery(true);
        setOpen(false);
      }
      return;
    }

    if (delAd === null && sel) {
      setDelAd(sel.delivery_address_id);
    }

    let payload = {};
    payload.delivery_id = sel.delivery_address_id;
    payload.product_id = datas.product_id;
    payload.coupon_id = couponSuccess?.coupon_id;
    payload.quantity = props?.count;
    payload.gift_message = formData?.gift_message;

    setLoading(true);
    fetch(backend + "createsingleorder", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (!response.ok) {
          setLoading(false);
          console.error(
            "Failed to register:",
            response.status,
            response.statusText
          );
          if (response.status === 409) {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
            });
          }
          return;
        }

        response.json().then((data) => {
          handlePayment(
            data.order_no,
            data.grandTotalPrice,
            data.user_details,
            data.razorpay_order_id
          );
        });
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  const handleOrderAddress = (item) => {
    let payload = {};
    payload.delivery_id = item.delivery_address_id;
    payload.product_id = datas.product_id;
    payload.coupon_id = couponSuccess?.coupon_id;
    payload.quantity = props?.count;

    setLoading(true);
    fetch(backend + "createsingleorder", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (!response.ok) {
          setLoading(false);
          console.error(
            "Failed to register:",
            response.status,
            response.statusText
          );
          if (response.status === 409) {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
            });
          }
          return;
        }

        response.json().then((data) => {
          handlePayment(
            data.order_no,
            data.grandTotalPrice,
            data.user_details,
            data.razorpay_order_id
          );
        });
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleSuccessOrder = (order_id, pay_id) => {
    setLoading(true);

    let payload = {};
    payload.razorpay_payment_id = pay_id;
    payload.order_no = order_id;
    payload.product_id = datas.product_id;

    fetch(backend + "successfullpayment", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (!response.ok) {
          setLoading(false);
          console.error(
            "Failed to register:",
            response.status,
            response.statusText
          );
          if (response.status === 409) {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
            });
          } else {
            toast.error("Payment verification failed", {
              position: "top-right",
              autoClose: 3000,
            });
          }

          return;
        }

        response
          .json()
          .then((data) => {
            setLoading(false);
            toast.success("Order Placed Successfully", {
              position: "top-right",
              autoClose: 3000,
            });
            navigate("/success");
          })
          .catch((err) => {
            setLoading(false);
            console.error("JSON Error:", err);
          });
      })
      .catch((error) => {
        setLoading(false);
        console.error("Fetch Error:", error);
      });
  };
  const handleCoupon = () => {
    let payload = {};
    payload.amount = datas?.mrp;
    payload.code = couponId;

    fetch(backend + "checkcoupon", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (!response.ok) {
          console.error(
            "Failed to register:",
            response.status,
            response.statusText
          );
          if (response.status === 401) {
            setCouponId("");
            toast.error("Invalid Coupon", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else if (response.status === 402) {
            toast.error("Not Applicable For this Amount", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else if (response.status === 403) {
            toast.error("Coupon Already Used", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
          return;
        }
        response.json().then((data) => {
          setCouponId("");
          setCoupon(2);
          setCouponSuccess(data);
          toast.success("Coupon Applied", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        });
        // navigate("/admin-users");
      })
      .catch((error) => { });
  };

  const handleDeleteAddress = async (id) => {
    try {
      const response = await fetch(backend + `deleteaddress/${id}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authenticated?.access_token}`,
        },
        body: JSON.stringify(),
      });

      if (response.status === 200) {
        fetchAddress();
        toast.success("Address Deleted", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else if (response.status === 409) {
      } else {
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <>
      <main className="main " id="main-section">

        <div className="wrapper">
          <div className="mb-80  ">
            <div className="row ">
              <div className="col-lg-12 d-block">
                <div className="d-flex justify-content-between">
                  <H2>Check Out</H2>

                </div>
                {/* Address summary like Cart */}
                <div className="">
                  <CartFlex>
                    <LeftCol>
                      <AddressBar>
                        <div className="address-left">
                          <span className="label">Deliver to:</span>
                          <span className="value">
                            {(() => {
                              const sel = address?.find((a) => a?.delivery_address_id === delAd) || (address && address[address.length - 1]);
                              return sel
                                ? `${sel?.first_name ?? ''} ${sel?.last_name ?? ''}, ${sel?.house_name ?? ''}, ${sel?.city ?? ''} ${sel?.pincode ?? ''}`.trim()
                                : `N/A`;
                            })()}
                          </span>
                        </div>
                        <ChangeButton type="button" onClick={() => setIsAddressModalOpen(true)}>Change</ChangeButton>
                      </AddressBar>
                      <div className="product-grid mx-1">
                        {loading && (
                          <div>
                            <LoaderMain />
                          </div>
                        )}
                        <CardBoxContainer>
                          {!loading &&
                            (datas ? (
                              <>
                                <CartBoxTop>
                                  <p>Item Name</p>
                                  <p>Price</p>
                                  <p>Quantity</p>
                                  <p>Total Amount</p>
                                  <p>Remove</p>
                                </CartBoxTop>
                                <CartBox
                                  className=" wow animate__animated animate__fadeIn"
                                  data-wow-delay="0.1s"
                                >
                                  <Section className="one">
                                    <div>
                                      <a
                                        onClick={() =>
                                          handleProductRoute(datas?.product_slug)
                                        }
                                      >
                                        <ImageContainer>
                                          <img
                                            // src={mediaurl + item.images}
                                            src={producturl + datas?.thumbnail}
                                          // alt="Nestle Original Coffee-Mate Coffee Creamer"
                                          />
                                          {/* <img
                                                            className="hover-img"
                                                            style={{
                                                              height: "200px",
                                                              width: "100%",
                                                              objectFit: "contain",
                                                              objectPosition: "center",
                                                            }}
                                                            src={producturl + item?.thumbnail2}
                                                            // alt="Nestle Original Coffee-Mate Coffee Creamer"
                                                          /> */}
                                        </ImageContainer>
                                      </a>
                                    </div>
                                    <div>
                                      <Link
                                        className="smallLink"
                                        onClick={() =>
                                          handleProductRoute(datas?.product_slug)
                                        }
                                      >
                                        {datas?.category_name}
                                      </Link>
                                      <Link
                                        href={`/product/${datas?.product_slug}`}
                                        onClick={() =>
                                          handleProductRoute(datas?.product_slug)
                                        } // title="Nestle Original Coffee-Mate Coffee Creamer"
                                      >
                                        {datas?.product_name}
                                      </Link>
                                      <div className="product-rate-cover">
                                        <div className="d-inline-block">
                                          <Rating
                                            name="read-only"
                                            value={datas?.average_stars}
                                            readOnly
                                            size="small"
                                          />
                                        </div>
                                        <span
                                          className="font-small ml-5 text-muted"
                                          style={{ verticalAlign: "top" }}
                                        >
                                          ({datas?.average_stars ?? "Not Yet Rated"})
                                        </span>
                                      </div>
                                      <span className="font-small text-muted">
                                        Sold By{" "}
                                        <b style={{ fontWeight: "700" }}>
                                          <a
                                          // onClick={() => handleProductRoute(item.product_slug)}
                                          >
                                            {datas?.manufacturer_name ??
                                              "KeralaSpecial"}
                                          </a>
                                        </b>
                                      </span>
                                    </div>
                                  </Section>
                                  <Section className="two">
                                    {" "}
                                    <div className="product-content-wrap">
                                      <span>₹ {datas?.mrp}{" "} </span>
                                    </div>
                                    <QtyBtn className="mobile">
                                      <Btn
                                        onClick={() =>
                                          props?.handleDecrement()
                                        }
                                      >
                                        <LuMinus />
                                      </Btn>
                                      <div>
                                        <input
                                          type="text"
                                          min="1"
                                          value={props.count}

                                        // onChange={(event) =>
                                        //   handleQuantityChange(
                                        //     item.cart_id,
                                        //     event.target.value
                                        //   )
                                        // }
                                        />
                                      </div>

                                      <Btn
                                        onClick={() =>
                                          props?.handleIncrement()
                                        }
                                      >
                                        <HiOutlinePlus />
                                      </Btn>
                                    </QtyBtn>
                                  </Section>
                                  <Section className="three">
                                    <QtyBtn>
                                      <Btn
                                        onClick={() =>
                                          props?.handleDecrement()}

                                      >
                                        <LuMinus />
                                      </Btn>
                                      <div>
                                        <input
                                          type="text"
                                          min="1"
                                          value={props.count}

                                        // onChange={(event) =>
                                        //   handleQuantityChange(
                                        //     item.cart_id,
                                        //     event.target.value
                                        //   )
                                        // }
                                        />
                                      </div>

                                      <Btn
                                        onClick={() =>
                                          props?.handleIncrement()
                                        }
                                      >
                                        <HiOutlinePlus />
                                      </Btn>
                                    </QtyBtn>
                                  </Section>
                                  <Section className="four">
                                    <div>
                                      <h3>₹ {datas?.mrp * props.count + datas?.shipping_charge}{" "} </h3>
                                    </div>
                                  </Section>
                                  <Section>
                                    <DeleteButton
                                      type="button"
                                      onClick={(e) => { e.stopPropagation(); props.handleDeleteCart(datas?.cart_id); }}
                                    >
                                      Delete
                                    </DeleteButton>
                                  </Section>

                                </CartBox>
                              </>
                            ) : (
                              <div className="empty-cart text-center " style={{ padding: "24px 0" }}>
                                <img
                                  src="/storage/general/cart.png"
                                  alt="Empty cart"
                                  className="mx-auto"
                                  style={{ width: 200, maxWidth: "60%", height: "auto", marginBottom: 12 }}
                                />
                                <h3 className="mt-2" style={{ color: "#111827", fontWeight: 700 }}>Your cart is empty</h3>
                                <p style={{ color: "#6b7280", margin: "6px 0 14px" }}>Explore products and add items to your cart.</p>
                                <button
                                  type="button"
                                  className="btn hover-up"
                                  style={{ background: "#fa9801", color: "#fff", border: "none", borderRadius: "10px", padding: "10px 16px", fontWeight: 600 }}
                                  onClick={() => navigate('/')}
                                >
                                  Explore Products
                                </button>
                              </div>
                            ))}
                        </CardBoxContainer>
                      </div>
                    </LeftCol>
                    <RightCol>
                      <SummaryCard>
                        <SummaryTitle>Price Details</SummaryTitle>
                        <SummaryRow>
                          <span>Price (1 Item)</span>
                          <span>₹ {datas?.mrp * (props?.count || 1)}</span>
                        </SummaryRow>
                        {couponSuccess ? (
                          <SummaryRow>
                            <span>Discount</span>
                            <DiscountValue>- ₹ {couponSuccess?.amount}</DiscountValue>
                          </SummaryRow>
                        ) : null}
                        <SummaryRow>
                          <span>Shipping Fee</span>
                          <span>₹ {datas?.shipping_charge || 0}</span>
                        </SummaryRow>
                        <Divider />
                        <SummaryRow className="total">
                          <span>Total Amount</span>
                          <span>
                            ₹ {(() => {
                              const base = datas?.mrp * (props?.count || 1);
                              const discount = couponSuccess ? (base - (base - couponSuccess?.amount)) : 0;
                              const sub = base - (couponSuccess ? couponSuccess?.amount : 0);
                              return (sub + (datas?.shipping_charge || 0));
                            })()}
                          </span>
                        </SummaryRow>
                        <OrderButton
                          type="button"
                          onClick={() => {
                            const sel = address?.find((a) => a?.delivery_address_id === delAd) || (address && address[address.length - 1]);
                            if (!sel) {
                              toast.info('Please add a delivery address to proceed with your order', { position: 'top-right', autoClose: 3000 });
                              setIsAddressModalOpen(true);
                              if (!address || address.length === 0) {
                                setNewDelivery(true);
                                setOpen(false);
                              }
                              return;
                            }
                            handleOrderAddress(sel);
                          }}
                        >
                          Checkout
                        </OrderButton>
                      </SummaryCard>
                    </RightCol>
                  </CartFlex>
                </div>
              </div>
            </div>

            <Modal show={isAddressModalOpen} onHide={() => setIsAddressModalOpen(false)} size="xl" centered>
              <Modal.Header closeButton>
                <Modal.Title>Delivery Address</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="mb-3 d-flex gap-2">
                  {address[0]?.city ? (
                    <ActionButton
                      onClick={() => {
                        setNewDelivery(!newDelivery);
                        setOpen(false);
                      }}
                      aria-controls="example-new-text"
                      aria-expanded={newDelivery}
                    >
                      <HiOutlinePlus /> Add New
                    </ActionButton>
                  ) : (
                    <ActionButton
                      onClick={() => {
                        setNewDelivery(false);
                        setOpen(!open);
                      }}
                      aria-controls="example-collapse-text"
                      aria-expanded={open}
                    >
                      <HiOutlinePlus /> Add New
                    </ActionButton>
                  )}
                </div>

                <div className="py-2">
                  <AddressGrid>
                    {address?.map((item, i) => {
                      const selected = delAd === item?.delivery_address_id;
                      return (
                        <AddressCard
                          key={i}
                          className={selected ? "selected" : ""}
                          onClick={() => setDelAd(item?.delivery_address_id)}
                        >
                          <div className="card-main">
                            <AddressName>{item?.first_name} {item?.last_name}</AddressName>
                            {item?.house_name && item?.city && item?.pincode ? (
                              <AddressMeta>
                                {item?.house_name}, {item?.street_name}, {item?.city}, {item?.state}, {item?.country_name} - {item?.pincode}
                                <br />PH NO: {item?.contact}
                              </AddressMeta>
                            ) : (
                              <AddressMeta>No more details</AddressMeta>
                            )}
                          </div>
                          <DeleteButton
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              if (window.confirm("Are you sure you want to delete this address?")) {
                                handleDeleteAddress(item?.delivery_address_id);
                              }
                            }}
                          >
                            Delete
                          </DeleteButton>
                        </AddressCard>
                      );
                    })}
                  </AddressGrid>
                  {delAd && (
                    <SelectedPreview>
                      {(() => {
                        const sel = address?.find(a => a?.delivery_address_id === delAd);
                        return sel ? (
                          <div>
                            <strong>Selected:</strong> {sel?.first_name} {sel?.last_name} — {sel?.house_name}, {sel?.street_name}, {sel?.city}, {sel?.state}, {sel?.country_name} - {sel?.pincode}. PH: {sel?.contact}
                          </div>
                        ) : null;
                      })()}
                    </SelectedPreview>
                  )}
                </div>

                {open && (
                  <div className="pt-2" id="example-collapse-text">
                    <ModalForm>
                      <div className="form__content">
                        <div className="row">
                          <div className="col-lg-4 col-md-4 col-6">
                            <div>
                              <label htmlFor="name">First Name</label> <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                              <input name="product_name" id="txt-name" type="text" value={formData?.first_name || ""} onChange={(e) => setFormData({ ...formData, first_name: e.target.value })} placeholder="First Name" />
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-4 col-6">
                            <div>
                              <label htmlFor="name">Last Name</label> <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                              <input name="last_name" id="txt-name" type="text" value={formData?.last_name || ""} onChange={(e) => setFormData({ ...formData, last_name: e.target.value })} placeholder="Last Name" />
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-4 col-12">
                            <div>
                              <label htmlFor="name">House Name / House Number / Apartment</label> <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                              <input name="house_name" id="txt-name" type="text" value={formData?.house_name || ""} onChange={(e) => setFormData({ ...formData, house_name: e.target.value })} placeholder="House Name / House Number / Apartment" />
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-4 col-6">
                            <div>
                              <label htmlFor="name">Street Name</label>
                              <input name="street_name" id="txt-name" type="text" value={formData?.street_name || ""} onChange={(e) => setFormData({ ...formData, street_name: e.target.value })} placeholder="Street Name" />
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-4 col-6">
                            <div>
                              <label htmlFor="city">City</label><sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                              <input type="text" name="city" required value={formData?.city || ""} onChange={(e) => setFormData({ ...formData, city: e.target.value })} placeholder="City" />
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-4 col-6">
                            <div>
                              <label htmlFor="state">State</label><sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                              <input type="text" name="state" required value={formData?.state || ""} onChange={(e) => setFormData({ ...formData, state: e.target.value })} placeholder="State" />
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-4 col-6">
                            <div>
                              <label htmlFor="country">Country</label><sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                              <select name="category_name" id="txt-name" required value={formData?.country || ""} onChange={(e) => setFormData({ ...formData, country: e.target.value })}>
                                <option>- select -</option>
                                {count.map((val) => (
                                  <option value={val.country_id}>{val.countryname}</option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-4 col-6">
                            <div>
                              <label htmlFor="pincode">Pin Code</label><sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                              <input type="text" name="pincode" required value={formData?.pincode || ""} maxLength={6} onChange={(e) => setFormData({ ...formData, pincode: e.target.value.replace(/[^0-9]/g, "") })} placeholder="Pincode" />
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-4 col-6">
                            <div>
                              <label htmlFor="street_name">Contact Number</label><sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                              <input type="text" name="phone" minLength={6} maxLength={12} required value={formData?.contact || ""} onChange={(e) => setFormData({ ...formData, contact: e.target.value.replace(/[^0-9+]/g, "") })} placeholder="Primary contact number" />
                            </div>
                          </div>
                          <div className="login_footer">
                            <div className="chek-form">
                              <div className="custome-checkbox">
                                <input className="form-check-input" type="checkbox" name="agree_terms_and_policy" id="agree-terms-and-policy" checked={formData?.is_primary === 0} onChange={(e) => setFormData({ ...formData, is_primary: e.target.checked ? 0 : 1 })} />
                                <label className="form-check-label" htmlFor="agree-terms-and-policy"><span><a>Set this as my primary address.</a></span></label>
                              </div>
                            </div>
                          </div>
                          <div>
                            <ActionButton type="button" onClick={() => handleSubmit()}>
                              Submit
                            </ActionButton>
                          </div>
                        </div>
                      </div>
                    </ModalForm>
                  </div>
                )}

                {newDelivery && (
                  <div className="pt-2" id="example-new-text">
                    <ModalForm>
                      <div className="form__content">
                        <div className="row">
                          <div className="col-lg-4 col-md-4 col-6">
                            <div>
                              <label htmlFor="name">First Name</label> <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                              <input name="product_name" id="txt-name" type="text" value={newAdd?.first_name || ""} onChange={(e) => setNewAdd({ ...newAdd, first_name: e.target.value })} placeholder="First Name" />
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-4 col-6">
                            <div>
                              <label htmlFor="name">Last Name</label> <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                              <input name="last_name" id="txt-name" type="text" value={newAdd?.last_name || ""} onChange={(e) => setNewAdd({ ...newAdd, last_name: e.target.value })} placeholder="Last Name" />
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-4 col-12">
                            <div>
                              <label htmlFor="name">House Name / House Number / Apartment</label> <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                              <input name="house_name" id="txt-name" type="text" value={newAdd.house_name || ""} onChange={(e) => setNewAdd({ ...newAdd, house_name: e.target.value })} placeholder="House Name / House Number / Apartment" />
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-4 col-6">
                            <div>
                              <label htmlFor="name">Street Name</label>
                              <input name="street_name" id="txt-name" type="text" value={newAdd.street_name || ""} onChange={(e) => setNewAdd({ ...newAdd, street_name: e.target.value })} placeholder="Street Name" />
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-4 col-6">
                            <div>
                              <label htmlFor="city">City</label><sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                              <input type="text" name="city" required value={newAdd.city || ""} onChange={(e) => setNewAdd({ ...newAdd, city: e.target.value })} placeholder="City" />
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-4 col-6">
                            <div>
                              <label htmlFor="state">State</label><sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                              <input type="text" name="state" required value={newAdd.state || ""} onChange={(e) => setNewAdd({ ...newAdd, state: e.target.value })} placeholder="State" />
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-4 col-6">
                            <div>
                              <label htmlFor="country">Country</label><sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                              <select name="category_name" id="txt-name" required value={newAdd.country || ""} onChange={(e) => setNewAdd({ ...newAdd, country: e.target.value })}>
                                <option>- select -</option>
                                {count.map((val) => (
                                  <option value={val.country_id}>{val.countryname}</option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-4 col-6">
                            <div>
                              <label htmlFor="pincode">Pin Code</label><sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                              <input type="text" name="pincode" required value={newAdd.pincode || ""} onChange={(e) => setNewAdd({ ...newAdd, pincode: e.target.value.replace(/[^0-9]/g, "") })} placeholder="Pincode" />
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-4 col-6">
                            <div>
                              <label htmlFor="street_name">Contact Number</label><sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                              <input type="text" name="phone" minLength={6} maxLength={12} required value={newAdd.contact || ""} onChange={(e) => setNewAdd({ ...newAdd, contact: e.target.value.replace(/[^0-9+]/g, "") })} placeholder="Primary contact number" />
                            </div>
                          </div>
                          <div>
                            <ActionButton type="button" onClick={() => handleSubmitNewAddress()}>
                              Submit
                            </ActionButton>
                          </div>
                        </div>
                      </div>
                    </ModalForm>
                  </div>
                )}
              </Modal.Body>
              <Modal.Footer>
                <SecondaryActionButton onClick={() => setIsAddressModalOpen(false)}>Close</SecondaryActionButton>
              </Modal.Footer>
            </Modal>

            <div className="d-block d-md-none d-lg-none">
              <div className="row product-grid">
                {!loading && datas.length > 0 && (
                  <>
                    <SubTotalContainer>
                      <SubTotal>
                        <h3>Cart Total </h3>
                        <Text>
                          <p>Product Total</p>
                          <p>: </p>
                          {couponSuccess ? (
                            <>
                              <s style={{ color: "#615EFC" }}>
                                {" "}
                                {datas?.mrp * props.count}
                              </s>{" "}
                              <div>
                                ₹
                                {datas?.mrp * props.count -
                                  couponSuccess?.amount}
                              </div>{" "}
                            </>
                          ) : (
                            <div> ₹{datas?.mrp * props.count}</div>
                          )}
                        </Text>
                        <Text>
                          <p>Shipping Charges</p>
                          <p>:</p>
                          <p>₹{datas?.shipping_charge}</p>
                        </Text>
                        <Text className="total">
                          <p>Sub Total</p>
                          <p>:</p>
                          <p>
                            {couponSuccess ? (
                              <>
                                <s style={{ color: "#3bb77e" }}>
                                  ₹{" "}
                                  {datas?.mrp * props.count +
                                    datas?.shipping_charge}
                                </s>{" "}
                                <div>
                                  ₹{" "}
                                  {datas?.mrp * props.count -
                                    couponSuccess?.amount +
                                    datas?.shipping_charge}
                                </div>{" "}
                              </>
                            ) : (
                              <div>
                                {" "}
                                ₹{" "}
                                {datas?.mrp * props.count +
                                  datas?.shipping_charge}
                              </div>
                            )}
                          </p>
                        </Text>
                        {!delivery ? (
                          <div className="d-flex justify-content-end gap-5 mt-5">
                            <div className="d-flex justify-content-between gap-5 mt-5">
                              <ActionButton
                                type="button"
                                // onClick={handlePayment}
                                onClick={() => setDelivery(!delivery)}
                                aria-controls="delivery-full"
                                aria-expanded={delivery}
                              >
                                Continue
                              </ActionButton>{" "}
                            </div>
                          </div>
                        ) : (
                          <div className="d-flex justify-content-end gap-5 mt-5">
                            <div className="d-flex justify-content-between gap-5 mt-5">
                              <SecondaryActionButton
                                type="button"
                                // onClick={handlePayment}
                                onClick={() => setDelivery(!delivery)}
                                aria-controls="delivery-full"
                                aria-expanded={delivery}
                              >
                                Back
                              </SecondaryActionButton>{" "}
                            </div>
                          </div>
                        )}
                      </SubTotal>
                    </SubTotalContainer>

                  </>
                )}
                <StyledCollapse in={delivery}>
                  <div className="mt-3" id="delivery-full">
                    <div className="col-lg-12">
                      <div className="d-flex justify-content-start">
                        <H2>Delivery Address</H2>
                      </div>
                    </div>
                    <div className="pt-4">
                      <div
                        className=" p-3 rounded border border-warning"
                        style={{
                          backgroundColor: "#fff",
                          alignContent: "start",
                        }}
                      >
                        <h6 className="heading-2 border-bottom pb-1 text-info d-flex justify-content-between">
                          {" "}
                          <>
                            <Button
                              onClick={() => {
                                setNewDelivery(!newDelivery);
                                setOpen(false);
                              }}
                              aria-controls="example-new-text"
                              aria-expanded={newDelivery}
                            >
                              {" "}
                              Add a New Delivery Address
                            </Button>
                            {/* <Button
                              onClick={() => {
                                setNewDelivery(false); setOpen(!open);
                              }}
                              aria-controls="example-collapse-text"
                              aria-expanded={open}
                            >Edit Primary Address
                            </Button> */}
                          </>
                        </h6>
                        <AddressGrid>
                          {address?.map((item, i) => {
                            const selected = delAd === item?.delivery_address_id;
                            return (
                              <AddressCard
                                key={i}
                                className={selected ? "selected" : ""}
                                onClick={() => setDelAd(item?.delivery_address_id)}
                              >
                                <div className="card-main">
                                  <AddressName>{item?.first_name} {item?.last_name}</AddressName>
                                  {item?.house_name && item?.city && item?.pincode ? (
                                    <AddressMeta>
                                      {item?.house_name}, {item?.street_name}, {item?.city}, {item?.state}, {item?.country_name} - {item?.pincode}
                                      <br />PH NO: {item?.contact}
                                    </AddressMeta>
                                  ) : (
                                    <AddressMeta>No more details</AddressMeta>
                                  )}
                                </div>
                              </AddressCard>
                            );
                          })}
                        </AddressGrid>
                        {delAd && (
                          <SelectedPreview>
                            {(() => {
                              const sel = address?.find(a => a?.delivery_address_id === delAd);
                              return sel ? (
                                <div>
                                  <strong>Selected:</strong> {sel?.first_name} {sel?.last_name} — {sel?.house_name}, {sel?.street_name}, {sel?.city}, {sel?.state}, {sel?.country_name} - {sel?.pincode}. PH: {sel?.contact}
                                </div>
                              ) : null;
                            })()}
                          </SelectedPreview>
                        )}
                      </div>
                    </div>

                    <StyledCollapse in={open}>
                      <div
                        className="pt-4"
                        data-wow-delay="0.1s"
                        id="example-collapse-text"
                      >
                        <div className="form__content">
                          <div className="row">
                            <div className="col-lg-4 col-md-4 col-6">
                              <div className="  ">
                                <label htmlFor="name">First Name</label>{" "}
                                <sup style={{ color: "red", fontSize: "13px" }}>
                                  *
                                </sup>
                                <input
                                  name="product_name"
                                  id="txt-name"
                                  type="text"
                                  // required
                                  value={formData?.first_name || ""}
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      first_name: e.target.value,
                                    })
                                  }
                                  placeholder="First Name"
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-6">
                              <div className="  ">
                                <label htmlFor="name">Last Name</label>{" "}
                                <sup style={{ color: "red", fontSize: "13px" }}>
                                  *
                                </sup>
                                <input
                                  name="last_name"
                                  id="txt-name"
                                  type="text"
                                  // required
                                  value={formData?.last_name || ""}
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      last_name: e.target.value,
                                    })
                                  }
                                  placeholder="Last Name"
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-12">
                              <div className="  ">
                                <label htmlFor="name">
                                  House Name / House Number / Apartment
                                </label>{" "}
                                <sup style={{ color: "red", fontSize: "13px" }}>
                                  *
                                </sup>
                                <input
                                  name="house_name"
                                  id="txt-name"
                                  type="text"
                                  // required
                                  value={formData?.house_name || ""}
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      house_name: e.target.value,
                                    })
                                  }
                                  placeholder="House Name / House Number / Apartment"
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-6">
                              <div className="  ">
                                <label htmlFor="name">Street Name</label>{" "}
                                {/* <sup style={{ color: "red", fontSize: "13px" }}>
                                  *
                                </sup> */}
                                <input
                                  name="street_name"
                                  id="txt-name"
                                  type="text"
                                  // required
                                  value={formData?.street_name || ""}
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      street_name: e.target.value,
                                    })
                                  }
                                  placeholder="Street Name"
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-6">
                              <div className="  ">
                                <label htmlFor="city">City</label>
                                <sup style={{ color: "red", fontSize: "13px" }}>
                                  *
                                </sup>
                                <input
                                  type="text"
                                  name="city"
                                  required
                                  value={formData?.city || ""}
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      city: e.target.value,
                                    })
                                  }
                                  placeholder="City"
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-6">
                              <div className="  ">
                                <label htmlFor="state">State</label>
                                <sup style={{ color: "red", fontSize: "13px" }}>
                                  *
                                </sup>
                                <input
                                  type="text"
                                  name="state"
                                  required
                                  value={formData?.state || ""}
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      state: e.target.value,
                                    })
                                  }
                                  placeholder="State"
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-6">
                              <div className="  ">
                                <label htmlFor="country">Country</label>
                                <sup style={{ color: "red", fontSize: "13px" }}>
                                  *
                                </sup>
                                <select
                                  name="category_name"
                                  id="txt-name"
                                  required
                                  value={formData?.country || ""}
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      country: e.target.value,
                                    })
                                  }
                                >
                                  <option>- select -</option>
                                  {count.map((val) => {
                                    return (
                                      <option value={val.country_id}>
                                        {val.countryname}
                                      </option>
                                    );
                                  })}
                                </select>
                              </div>
                            </div>

                            <div className="col-lg-4 col-md-4 col-6">
                              <div className="  ">
                                <label htmlFor="pincode">Pin Code</label>
                                <sup style={{ color: "red", fontSize: "13px" }}>
                                  *
                                </sup>
                                <input
                                  type="text"
                                  name="pincode"
                                  required
                                  value={formData?.pincode || ""}
                                  maxLength={6}
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      pincode: e.target.value.replace(
                                        /[^0-9]/g,
                                        ""
                                      ),
                                    })
                                  }
                                  placeholder="Pincode"
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-6">
                              <div className="  ">
                                <label htmlFor="street_name">
                                  Contact Number
                                </label>
                                <sup style={{ color: "red", fontSize: "13px" }}>
                                  *
                                </sup>
                                <input
                                  type="text"
                                  name="phone"
                                  minLength={6}
                                  maxLength={12}
                                  required
                                  value={formData?.contact || ""}
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      contact: e.target.value.replace(
                                        /[^0-9+]/g,
                                        ""
                                      ),
                                    })
                                  }
                                  placeholder="Primary contact number"
                                />
                              </div>
                            </div>
                            <div className="login_footer   ">
                              <div className="chek-form">
                                <div className="custome-checkbox">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    name="agree_terms_and_policy"
                                    id="agree-terms-and-policy"
                                    checked={formData?.is_primary === 0} // Check if is_primary is 1
                                    onChange={(e) =>
                                      setFormData({
                                        ...formData,
                                        is_primary: e.target.checked ? 0 : 1, // Set to 1 if checked, 0 otherwise
                                      })
                                    }
                                  />

                                  <label
                                    className="form-check-label"
                                    for="agree-terms-and-policy"
                                  >
                                    <span>
                                      <a>Set this as my primary address.</a>
                                    </span>
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="d-flex justify-content-end gap-5 ">
                              <div className="d-flex justify-content-between gap-5">
                                <h3 className="heading-4 product-price text-success">
                                  SUBTOTAL
                                </h3>
                                <h3 className="heading-4 product-price text-success">
                                  {couponSuccess ? (
                                    <>
                                      <s style={{ color: "#3bb77e" }}>
                                        ₹{" "}
                                        {datas?.mrp * props.count +
                                          datas?.shipping_charge}
                                      </s>{" "}
                                      <div>
                                        ₹{" "}
                                        {datas?.mrp * props.count -
                                          couponSuccess?.amount +
                                          datas?.shipping_charge}
                                      </div>{" "}
                                    </>
                                  ) : (
                                    <div>
                                      {" "}
                                      ₹{" "}
                                      {datas?.mrp * props.count +
                                        datas?.shipping_charge}
                                    </div>
                                  )}
                                </h3>
                              </div>
                            </div>
                            <div className="d-flex justify-content-end ">
                              <div className="d-flex justify-content-end ">
                                <h5 className="heading-4 product-price text-secondary">
                                  (PRODUCT TOTAL ₹{" "}
                                </h5>
                                <h5 className="heading-4 product-price text-secondary">
                                  {couponSuccess ? (
                                    <>
                                      <s style={{ color: "#615EFC" }}>
                                        {" "}
                                        {datas?.mrp * props.count}
                                      </s>{" "}
                                      <div>
                                        {" "}
                                        {datas?.mrp * props.count -
                                          couponSuccess?.amount}
                                        )
                                      </div>{" "}
                                    </>
                                  ) : (
                                    <div> {datas?.mrp * props.count})</div>
                                  )}
                                </h5>
                              </div>
                            </div>
                            <div className="d-flex justify-content-end ">
                              <div className="d-flex justify-content-start ">
                                <h5 className="heading-4 product-price text-secondary">
                                  (SHIPPING CHARGE ₹{" "}
                                </h5>
                                <h5 className="heading-4 product-price text-secondary">
                                  {datas?.shipping_charge})
                                </h5>
                              </div>
                            </div>
                            <div className="  ">
                              <ActionButton
                                type="button"
                                onClick={() => handleSubmit()}
                              >
                                Submit
                              </ActionButton>
                            </div>
                          </div>
                        </div>
                      </div>
                    </StyledCollapse>
                    <StyledCollapse in={newDelivery}>
                      <div
                        className="pt-4"
                        data-wow-delay="0.1s"
                        id="example-new-text"
                      >
                        <div className="form__content">
                          <div className="row">
                            <div className=" col-12">
                              <div className="  ">
                                <label htmlFor="name">First Name</label>{" "}
                                <sup style={{ color: "red", fontSize: "13px" }}>
                                  *
                                </sup>
                                <input
                                  name="product_name"
                                  id="txt-name"
                                  type="text"
                                  style={{
                                    backgroundColor: "#fff",
                                    color: "#000",
                                    border: "1px solid #000",
                                  }}
                                  value={newAdd?.first_name || ""}
                                  onChange={(e) =>
                                    setNewAdd({
                                      ...newAdd,
                                      first_name: e.target.value,
                                    })
                                  }
                                  placeholder="First Name"
                                />
                              </div>
                            </div>
                            <div className=" col-12">
                              <div className="  ">
                                <label htmlFor="name">Last Name</label>{" "}
                                <sup style={{ color: "red", fontSize: "13px" }}>
                                  *
                                </sup>
                                <input
                                  name="last_name"
                                  id="txt-name"
                                  type="text"
                                  style={{
                                    backgroundColor: "#fff",
                                    color: "#000",
                                    border: "1px solid #000",
                                  }}
                                  value={newAdd?.last_name || ""}
                                  onChange={(e) =>
                                    setNewAdd({
                                      ...newAdd,
                                      last_name: e.target.value,
                                    })
                                  }
                                  placeholder="Last Name"
                                />
                              </div>
                            </div>
                            <div className=" col-12">
                              <div className="  ">
                                <label htmlFor="name">
                                  House Name / House Number / Apartment
                                </label>{" "}
                                <sup style={{ color: "red", fontSize: "13px" }}>
                                  *
                                </sup>
                                <input
                                  name="house_name"
                                  id="txt-name"
                                  type="text"
                                  style={{
                                    backgroundColor: "#fff",
                                    color: "#000",
                                    border: "1px solid #000",
                                  }}
                                  value={newAdd?.house_name || ""}
                                  onChange={(e) =>
                                    setNewAdd({
                                      ...newAdd,
                                      house_name: e.target.value,
                                    })
                                  }
                                  placeholder="House Name / House Number / Apartment"
                                />
                              </div>
                            </div>
                            <div className=" col-12">
                              <div className="  ">
                                <label htmlFor="name">Street Name</label>{" "}
                                <sup style={{ color: "red", fontSize: "13px" }}>
                                  *
                                </sup>
                                <input
                                  name="street_name"
                                  id="txt-name"
                                  type="text"
                                  style={{
                                    backgroundColor: "#fff",
                                    color: "#000",
                                    border: "1px solid #000",
                                  }}
                                  value={newAdd?.street_name || ""}
                                  onChange={(e) =>
                                    setNewAdd({
                                      ...newAdd,
                                      street_name: e.target.value,
                                    })
                                  }
                                  placeholder="Street Name"
                                />
                              </div>
                            </div>

                            <div className=" col-12">
                              <div className="  ">
                                <label htmlFor="city">City</label>
                                <sup style={{ color: "red", fontSize: "13px" }}>
                                  *
                                </sup>
                                <input
                                  type="text"
                                  name="city"
                                  required
                                  style={{
                                    backgroundColor: "#fff",
                                    color: "#000",
                                    border: "1px solid #000",
                                  }}
                                  value={newAdd?.city || ""}
                                  onChange={(e) =>
                                    setNewAdd({
                                      ...newAdd,
                                      city: e.target.value,
                                    })
                                  }
                                  placeholder="City"
                                />
                              </div>
                            </div>
                            <div className=" col-12">
                              <div className="  ">
                                <label htmlFor="state">State</label>
                                <sup style={{ color: "red", fontSize: "13px" }}>
                                  *
                                </sup>
                                <input
                                  type="text"
                                  name="state"
                                  required
                                  style={{
                                    backgroundColor: "#fff",
                                    color: "#000",
                                    border: "1px solid #000",
                                  }}
                                  value={newAdd?.state || ""}
                                  onChange={(e) =>
                                    setNewAdd({
                                      ...newAdd,
                                      state: e.target.value,
                                    })
                                  }
                                  placeholder="State"
                                />
                              </div>
                            </div>
                            <div className=" col-12">
                              <div className="  ">
                                <label htmlFor="country">Country</label>
                                <sup style={{ color: "red", fontSize: "13px" }}>
                                  *
                                </sup>
                                <select
                                  name="category_name"
                                  id="txt-name"
                                  required
                                  style={{
                                    backgroundColor: "#fff",
                                    color: "#000",
                                    border: "1px solid #000",
                                  }}
                                  value={newAdd?.country || ""}
                                  onChange={(e) =>
                                    setNewAdd({
                                      ...newAdd,
                                      country: e.target.value,
                                    })
                                  }
                                >
                                  <option>- select -</option>
                                  {count.map((val) => {
                                    return (
                                      <option value={val.country_id}>
                                        {val.countryname}
                                      </option>
                                    );
                                  })}
                                </select>
                              </div>
                            </div>

                            <div className=" col-12">
                              <div className="  ">
                                <label htmlFor="pincode">Pin Code</label>
                                <sup style={{ color: "red", fontSize: "13px" }}>
                                  *
                                </sup>
                                <input
                                  type="text"
                                  name="pincode"
                                  required
                                  style={{
                                    backgroundColor: "#fff",
                                    color: "#000",
                                    border: "1px solid #000",
                                  }}
                                  value={newAdd?.pincode || ""}
                                  onChange={(e) =>
                                    setNewAdd({
                                      ...newAdd,
                                      pincode: e.target.value.replace(
                                        /[^0-9]/g,
                                        ""
                                      ),
                                    })
                                  }
                                  placeholder="Pincode"
                                />
                              </div>
                            </div>
                            <div className=" col-12">
                              <div className="  ">
                                <label htmlFor="street_name">
                                  Contact Number
                                </label>
                                <sup style={{ color: "red", fontSize: "13px" }}>
                                  *
                                </sup>
                                <input
                                  type="text"
                                  name="phone"
                                  style={{
                                    backgroundColor: "#fff",
                                    color: "#000",
                                    border: "1px solid #000",
                                  }}
                                  minLength={6}
                                  maxLength={12}
                                  required
                                  value={newAdd?.contact || ""}
                                  onChange={(e) =>
                                    setNewAdd({
                                      ...newAdd,
                                      contact: e.target.value.replace(
                                        /[^0-9+]/g,
                                        ""
                                      ),
                                    })
                                  }
                                  placeholder="Primary contact number"
                                />
                              </div>
                            </div>
                            {/* <div className="login_footer   ">
                              <div className="chek-form">
                                <div className="custome-checkbox">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    name="agree_terms_and_policy"
                                    id="agree-terms-and-policy"
                                    checked={newAdd.is_primary === 0}
                                    onChange={(e) =>
                                      setNewAdd({
                                        ...newAdd,
                                        is_primary: e.target.checked ? 0 : 1,                                      })
                                    }
                                  />
                                  <label
                                    className="form-check-label"
                                    for="agree-terms-and-policy"
                                  >
                                    <span>
                                      <a>
                                        Set this as my primary address.</a>
                                    </span>
                                  </label>
                                </div>
                              </div>
                            </div> */}

                            <div className="d-flex justify-content-end gap-5 ">
                              <div className="d-flex justify-content-between gap-5">
                                <h5 className="heading-4 product-price text-white">
                                  SUBTOTAL{" "}
                                </h5>
                                <h5 className="heading-4 product-price text-white">
                                  {couponSuccess ? (
                                    <>
                                      <s style={{ color: "#B06161" }}>
                                        ₹{" "}
                                        {datas?.mrp * props.count +
                                          datas?.shipping_charge}
                                      </s>{" "}
                                      <div>
                                        ₹{" "}
                                        {datas?.mrp * props.count -
                                          couponSuccess?.amount +
                                          datas?.shipping_charge}
                                      </div>{" "}
                                    </>
                                  ) : (
                                    <div>
                                      {" "}
                                      ₹{" "}
                                      {datas?.mrp * props.count +
                                        datas?.shipping_charge}
                                    </div>
                                  )}
                                </h5>
                              </div>
                            </div>
                            <div className="d-flex justify-content-end ">
                              <div className="d-flex justify-content-end ">
                                <h6 className="heading-4 product-price text-secondary">
                                  (PRODUCT TOTAL ₹{" "}
                                </h6>
                                <h6 className="heading-4 product-price text-secondary">
                                  {couponSuccess ? (
                                    <>
                                      <s style={{ color: "#B06161" }}>
                                        {" "}
                                        {datas?.mrp * props.count}
                                      </s>{" "}
                                      <div>
                                        {" "}
                                        {datas?.mrp * props.count -
                                          couponSuccess?.amount}
                                        )
                                      </div>{" "}
                                    </>
                                  ) : (
                                    <div> {datas?.mrp * props.count})</div>
                                  )}
                                </h6>
                              </div>
                            </div>
                            <div className="d-flex justify-content-end ">
                              <div className="d-flex justify-content-start ">
                                <h6 className="heading-4 product-price text-secondary">
                                  (SHIPPING CHARGE ₹{" "}
                                </h6>
                                <h6 className="heading-4 product-price text-secondary">
                                  {datas?.shipping_charge})
                                </h6>
                              </div>
                            </div>
                            <div className="   mt-20">
                              <ActionButton
                                type="button"
                                onClick={() => handleSubmitNewAddress()}
                              >
                                Submit
                              </ActionButton>
                            </div>
                          </div>
                        </div>
                      </div>
                    </StyledCollapse>
                    {!newDelivery && !open && (
                      <>
                        <div className="d-flex justify-content-end gap-5 ">
                          <div className="d-flex justify-content-between gap-5">
                            <h5 className="heading-4 product-price text-white">
                              SUBTOTAL
                            </h5>
                            <h5 className="heading-4 product-price text-white">
                              {couponSuccess ? (
                                <>
                                  <s style={{ color: "#B06161" }}>
                                    ₹{" "}
                                    {datas?.mrp * props.count +
                                      datas?.shipping_charge}
                                  </s>{" "}
                                  <div>
                                    ₹{" "}
                                    {datas?.mrp * props.count -
                                      couponSuccess?.amount +
                                      datas?.shipping_charge}
                                  </div>{" "}
                                </>
                              ) : (
                                <div>
                                  {" "}
                                  ₹{" "}
                                  {datas?.mrp * props.count +
                                    datas?.shipping_charge}
                                </div>
                              )}
                            </h5>
                          </div>
                        </div>
                        <div className="d-flex justify-content-end ">
                          <div className="d-flex justify-content-end ">
                            <h6 className="heading-4 product-price text-secondary">
                              (PRODUCT TOTAL ₹{" "}
                            </h6>
                            <h6 className="heading-4 product-price text-secondary">
                              {couponSuccess ? (
                                <>
                                  <s style={{ color: "#B06161" }}>
                                    ₹ {datas?.mrp * props.count}
                                  </s>{" "}
                                  <div>
                                    {" "}
                                    {datas?.mrp * props.count -
                                      couponSuccess?.amount}
                                    )
                                  </div>{" "}
                                </>
                              ) : (
                                <div> {datas?.mrp * props.count})</div>
                              )}
                            </h6>
                          </div>
                        </div>
                        <div className="d-flex justify-content-end ">
                          <div className="d-flex justify-content-start ">
                            <h6 className="heading-4 product-price text-secondary">
                              (SHIPPING CHARGE ₹{" "}
                            </h6>
                            <h6 className="heading-4 product-price text-secondary">
                              {datas?.shipping_charge})
                            </h6>
                          </div>
                        </div>
                        <div className="d-flex justify-content-end gap-5 mt-5">
                          <div className="d-flex justify-content-between gap-5 mt-5">
                            <ActionButton
                              type="button"
                              onClick={handleOrder}
                              style={{ width: "100%", justifyContent: "center" }}
                            >
                              Check Out
                            </ActionButton>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </StyledCollapse>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        <ScrollToTop />
      </main>
    </>
  );
}
export default BuyNow;
const H2 = styled.h2`
  font-weight: 500;
  padding: 20px 0;
  @media screen and (max-width: 640px) {
    font-size: 25px;
  }
`;
const CardBoxContainer = styled.div`
  display: grid;
  row-gap: 16px;
  @media screen and (max-width: 1080px) {
    grid-template-columns: 1fr;
    column-gap: 0;
  }
`;
const CartBox = styled.div`
  position: relative;
  background: #ffffff;
  border: 1px solid #988181;
  border-radius: 14px;
  padding: 16px;
  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.06);
  transition: transform .15s ease, box-shadow .15s ease, border-color .15s ease;
  display: grid;
  grid-template-columns: 2fr 0.8fr 0.8fr 0.8fr 0.5fr;
  align-items: center;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 30px rgba(16, 24, 40, 0.1);
    border-color: #e6ebf0;
  }

  @media screen and (max-width: 1080px) {
    grid-template-columns: 1fr;
    row-gap: 12px;
  }
`;
const CartBoxTop = styled.div`
  display: grid;
  grid-template-columns: 2fr 0.8fr 0.8fr 0.8fr 0.5fr;
  padding: 6px 8px;
  margin: 10px 0 0 0;
  color: #667085;
  font-size: 13px;
  p {
    text-align: center;
    &:first-child { text-align: left; }
  }
  @media screen and (max-width: 1080px) { display: none; }
`;

const Section = styled.div`
  display: grid;
  justify-items: center;
  align-items: center;
  &.one {
    justify-self: start;
    padding: 6px 12px;
    display: grid;
    grid-template-columns: 200px 1fr;
    gap: 16px;
    align-items: center;
    img {
      border-radius: 10px;
    }
    @media screen and (max-width: 1080px) {
      grid-template-columns: 1fr;
      place-items: center;
      width: 100%;
    }
  }
  &.two {
    text-align: center;
    span {
      font-size: 22px;
      font-weight: 700;
      color: #101828;
    }
    @media screen and (max-width: 1080px) {
      display: grid;
      grid-template-columns: 1fr 1fr;
      align-items: center;
      justify-items: center;
      width: 100%;
      margin-bottom: 12px;
    }
  }
  &.three {
    @media screen and (max-width: 1080px) {
      display: none;
    }
  }
  &.four {
    h3 {
      text-align: center;
      font-size: 20px;
      font-weight: 700;
      color: #101828;
    }
    span {
      font-size: 13px;
      color: #475467;
    }
  }
`;
const ImageContainer = styled.div`
  height: 160px;
  width: 160px;
  border-radius: 12px;
  overflow: hidden;
  background: #f8fafc;
  border: 1px solid #eef2f6;

  img {
    height: 100%;
    width: 100%;
    display: block;
    object-fit: cover;
  }
`;
const Link = styled.a`
  display: block;
  color: #111827;
  font-weight: 700;
  font-size: 20px;
  line-height: 1.2;
  text-transform: capitalize;
  margin-bottom: 6px;
  &.smallLink {
    font-size: 13px;
    font-weight: 500;
    color: #475467;
    margin-bottom: 8px;
  }
`;
const QtyBtn = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  padding: 6px 10px;
  input {
    border: none;
    background: transparent;
    padding: 0 2px;
    display: inline-block;
    width: 36px;
    text-align: center;
    -moz-appearance: textfield; /* Firefox */
    -webkit-appearance: none; /* Safari/Chrome */
    appearance: none;
    font-size: 16px;
    font-weight: 700;
    color: #111827;
  }
  svg {
    font-size: 18px;
    color: #111827;
  }

  &.mobile {
    display: none;
    @media screen and (max-width: 1080px) {
      display: inline-flex;
    }
  }
`;
const Btn = styled.div`
  border: 1px solid #e5e7eb;
  background: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border-radius: 999px;
  transition: background .15s ease, border-color .15s ease;
  &:hover { background: #f3f4f6; border-color: #d1d5db; }
`;
const SubTotalContainer = styled.div`
  display: grid;
  width: 100%;
  justify-items: end;
  margin: 30px 0;
`;
const SubTotal = styled.div`
  box-shadow: 0px 0px 14px #00000034;
  h3 {
    font-size: 28px;
    font-weight: 600;
    margin-bottom: 20px;
  }
  button {
    margin-top: 20px;
  }

  display: inline-block;
  padding: 20px;
  border-radius: 10px;
`;
const Text = styled.div`
  display: grid;
  grid-template-columns: 1fr 0.2fr 1fr;
  &.total {
    p {
      font-size: 23px;
      font-weight: 600;
    }
  }
`;
const BackBtn = styled.div`
  margin: 0;
  background-color: #094c27;
  padding: 10px 25px;
  font-weight: 600;
  color: #fff;
  border-radius: 6px;
  font-size: 17px;
`;
const StyledCollapse = styled(Collapse)`
  input,
  select {
    border: 1px solid #6b6b6b;
    border-radius: 10px;
    padding: 10px 0;
    margin-bottom: 20px;
    font-family: "Montserrat";
    padding-left: 20px;
    &::placeholder {
      font-family: "Montserrat";
    }
  }
`;

const AddressGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
  margin-top: 16px;
`;

const AddressCard = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 14px;
  background: #fff;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  }
  &.selected {
    border-color: #3bb77e;
    box-shadow: 0 0 0 3px rgba(59, 183, 126, 0.15);
  }
  .card-main {
    flex: 1;
  }
`;

const AddressName = styled.div`
  font-weight: 600;
  color: #253d4e;
  margin-bottom: 6px;
`;

const AddressMeta = styled.div`
  color: #6b7280;
  font-size: 14px;
  line-height: 1.4;
`;

const DeleteButton = styled.button`
  border: none;
  background: #fff5f5;
  color: #e11d48;
  padding: 6px 12px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 13px;
  height: fit-content;
  transition: all 0.2s ease;
  border: 1px solid #fee2e2;
  cursor: pointer;

  &:hover {
    background: #e11d48;
    color: #fff;
    border-color: #e11d48;
    transform: scale(0.95);
  }

  &:active {
    transform: scale(0.9);
  }
`;

const SelectedPreview = styled.div`
  margin-top: 12px;
  padding: 10px 12px;
  border-left: 3px solid #3bb77e;
  background: #f0fff7;
  border-radius: 6px;
  color: #253d4e;
`;

const ModalForm = styled.div`
  .form__content input,
  .form__content select {
    border: 1px solid #d1d5db;
    border-radius: 10px;
    padding: 10px 12px;
    background: #fff;
    color: #111827;
  }
`;

// Cart-like layout wrappers
const CartFlex = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 0.8fr;
  gap: 18px;
  align-items: start;
  @media (max-width: 1080px) {
    grid-template-columns: 1fr;
  }
`;
const LeftCol = styled.div``;
const RightCol = styled.div``;
const AddressBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #988181;
  border-radius: 10px;
  padding: 14px 16px;
  margin-bottom: 16px;
  .label { color: #3a3a3a; font-weight: 500; margin-right: 10px; }
  .value { color: #111; font-weight: 600; }
`;
const ChangeButton = styled.button`
  border: 1px solid #187837;
  color: #187837;
  background: #fff;
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 14px;
  cursor: pointer;
  transition: all .2s ease;
  &:hover { background: #187837; color: #fff; }
`;
const SummaryCard = styled.div`
  background: #ffffff;
  border: 1px solid #988181;
  border-radius: 14px;
  padding: 16px;
  position: sticky;
  top: 20px;
  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.06);
`;
const SummaryTitle = styled.h4`
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 12px 0;
`;
const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  &.total { font-size: 16px; font-weight: 700; }
  span { font-size: 14px; color: #475467; }
`;
const DiscountValue = styled.span`
  color: #2ba24c;
`;
const Divider = styled.div`
  height: 1px;
  background: #e5e5e5;
  margin: 8px 0 12px 0;
`;
const OrderButton = styled.button`
  width: 100%;
  background: #ff8c1a;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 12px 16px;
  font-weight: 700;
  cursor: pointer;
  transition: background .2s ease, transform .1s ease;
  &:hover { background: #f38108; }
  &:active { transform: translateY(1px); }
`;

const ActionButton = styled.button`
  background: #3bb77e;
  color: #fff;
  border: none;
  padding: 8px 18px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 14px rgba(59, 183, 126, 0.25);
  cursor: pointer;

  &:hover {
    background: #2faa70;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(59, 183, 126, 0.35);
  }

  &:active {
    transform: scale(0.96);
  }

  svg {
    font-size: 18px;
  }
`;

const SecondaryActionButton = styled.button`
  background: #f8fafc;
  color: #475569;
  border: 1px solid #e2e8f0;
  padding: 8px 18px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;

  &:hover {
    background: #f1f5f9;
    color: #1e293b;
    border-color: #cbd5e1;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  }

  &:active {
    transform: scale(0.96);
  }
`;
